'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = parse;

var _diffusion = require('diffusion');

var _diffusion2 = _interopRequireDefault(_diffusion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMetadata() {
    /* eslint-disable-next-line new-cap */
    var metadata = _diffusion2.default.metadata.RecordContent();
    metadata.addRecord('Record', { min: 1, max: -1 }).addField('field', metadata.string(), { min: 1, max: -1 });
    return metadata;
}

function createBinaryParser() {
    var metadata = getMetadata();
    return {
        parse: metadata.parse.bind(metadata)
    };
}

/**
 * Parse diffusion Record into two-dementional array.
 * @memberOf SquashedSubscription
 * @instance
 * @param {Object} data Parsed diffusion record.
 * @returns {String[][]} Two-dimensional array with records and fields as dimensions.
 */
function fromRecordContent(data) {
    return data.records().map(function (record) {
        return record.fields();
    });
}

var binaryParser = createBinaryParser();
function parse(data) {
    var recordContent = binaryParser.parse(data);
    return fromRecordContent(recordContent);
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/binaryParser.js
// module id = 1374
// module chunks = 1